import {Box, Button, Input} from '@viptech/react-components'
import {useEffect, useState} from 'react'
import {UploadPhotos} from 'src/common/components/register-facial-recognition/components/upload-photos/UploadPhotos'
import ModalLateral, {ModalLateralFooter} from 'src/components/modal/ModalLateral'
import useUpdateFace from 'src/hooks/api/facial/useUpdateFace'
import createStyleSheet from 'src/utilities/createStyleSheet'
import {FacialListDTO} from '../../../../common/models/facial-recognition/FacialListDTO'

type ViewFaceModalProps = {
  isOpen: boolean
  closeModal: (shouldUpdateTable: boolean) => void
  faceSelected: FacialListDTO
}

function UpdateFaceModal({isOpen, closeModal, faceSelected}: ViewFaceModalProps) {
  const [name, setName] = useState(faceSelected.name)
  const [newImages, setNewImages] = useState<Array<File> | null>([])
  const [deleteFaces, setDeleteFaces] = useState<Array<number>>([])

  const {mutateAsync, isPending: isLoading} = useUpdateFace()

  function handleClose(updateTable: boolean) {
    setName('')
    closeModal(updateTable)
  }

  async function handleEditFace() {
    await mutateAsync({id: faceSelected.id, name: name, images: newImages ?? undefined, deleteFaceImageIds: deleteFaces})
    handleClose(true)
  }

  useEffect(() => {
    if (!name) setName(faceSelected.name)
  }, [faceSelected.name])

  return (
    <ModalLateral isOpen={isOpen} closeModal={() => handleClose(false)} title='Editar Face Cadastrada'>
      <Box display='flex' direction='column' justifyContent='space-between' minWidth='500px' style={styles.overflow} maxHeight='90vh'>
        <Box paddingTop='20px' display='flex' direction='column' justifyContent='space-between'>
          <Box width='100%' display='flex' direction='column' justify='center' align='center' rowGap='30px'>
            <Input.Root
              labelFontSize='14px'
              borderColor='#D0D5DD'
              fontSize='12px'
              labelFontWeight='400'
              label='Nome cadastrado'
              value={name}
              defaultValue={faceSelected.name}
              onChange={(e) => setName(e.target.value)}
            />

            <UploadPhotos
              onRemoveItem={(id) => setDeleteFaces((prev) => [...prev, id])}
              handleFiles={setNewImages}
              initialData={
                faceSelected.faceImages?.map((face) => ({
                  image: `${process.env.REACT_APP_TEMPLATE_IMAGES_BASE_URL}/${face.aws_cropped_image_key}`,
                  id: face.id.toString(),
                })) || []
              }
            />
          </Box>

          <ModalLateralFooter>
            <Box display='flex' columnGap='12px' justify='flex-end' padding='0 40px'>
              <Button fontSize='12px' height='38px' width='120px' variant='outlined' color='#8E8E8E' onClick={() => handleClose(false)}>
                Cancelar
              </Button>
              <Button
                fontSize='12px'
                height='38px'
                width='120px'
                disabledTextColor='#8E8E8E'
                onClick={() => handleEditFace()}
                isLoading={isLoading}
                disabled={name === faceSelected.name && !newImages?.length && !deleteFaces.length}>
                Salvar
              </Button>
            </Box>
          </ModalLateralFooter>
        </Box>
      </Box>
    </ModalLateral>
  )
}

export default UpdateFaceModal

const styles = createStyleSheet({
  overflow: {
    paddingRight: 6,
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    '-ms-overflow-style': 'none',
  },
})
